/*
Monotype Foundry Platform API
Version 1.0.0

Definition: Bundle

Properties:
  assets: object
  collection: array
  createdAt: string
  deReleaseDate: string
  description: array
  foundries: array
  id: string
  lastLiveUpdatedAt: string
  mode: string
  msrp: number
  name: string
  partNumber: string
  prices: array
  revisionId: string
  state: string
  submittedAt: string
  updatedAt: string
*/

var Bundle = (function () {
  function validateBundle (arg) {
    // Validate assets
    if (arg.assets && !(typeof arg.assets === 'object')) {
      throw new Error('Bundle.assets: Wrong type: Got \'' + (typeof arg.assets) + '\', but expected: \'object\'')
    }
    // Validate collection
    if (arg.collection && !(Array.isArray(arg.collection))) {
      throw new Error('Bundle.collection: Wrong type: Got \'' + (typeof arg.collection) + '\', but expected: \'array\'')
    }
    // Validate deReleaseDate
    if (arg.deReleaseDate && !(typeof arg.deReleaseDate === 'string')) {
      throw new Error('Bundle.deReleaseDate: Wrong type: Got \'' + (typeof arg.deReleaseDate) + '\', but expected: \'string\'')
    }
    // Validate description
    if (arg.description && !(Array.isArray(arg.description))) {
      throw new Error('Bundle.description: Wrong type: Got \'' + (typeof arg.description) + '\', but expected: \'array\'')
    }
    // Validate foundries
    if (arg.foundries && !(Array.isArray(arg.foundries))) {
      throw new Error('Bundle.foundries: Wrong type: Got \'' + (typeof arg.foundries) + '\', but expected: \'array\'')
    }
    // Validate lastLiveUpdatedAt
    if (arg.lastLiveUpdatedAt && !(typeof arg.lastLiveUpdatedAt === 'string')) {
      throw new Error('Bundle.lastLiveUpdatedAt: Wrong type: Got \'' + (typeof arg.lastLiveUpdatedAt) + '\', but expected: \'string\'')
    }
    // Validate mode
    if (arg.mode && !(typeof arg.mode === 'string')) {
      throw new Error('Bundle.mode: Wrong type: Got \'' + (typeof arg.mode) + '\', but expected: \'string\'')
    }
    // Validate msrp
    if (arg.msrp && !(typeof arg.msrp === 'number')) {
      throw new Error('Bundle.msrp: Wrong type: Got \'' + (typeof arg.msrp) + '\', but expected: \'number\'')
    }
    // Validate name
    if (arg.name && !(typeof arg.name === 'string')) {
      throw new Error('Bundle.name: Wrong type: Got \'' + (typeof arg.name) + '\', but expected: \'string\'')
    }
    // Validate partNumber
    if (arg.partNumber && !(typeof arg.partNumber === 'string')) {
      throw new Error('Bundle.partNumber: Wrong type: Got \'' + (typeof arg.partNumber) + '\', but expected: \'string\'')
    }
    // Validate prices
    if (arg.prices && !(Array.isArray(arg.prices))) {
      throw new Error('Bundle.prices: Wrong type: Got \'' + (typeof arg.prices) + '\', but expected: \'array\'')
    }
    // Validate state
    if (arg.state && !(typeof arg.state === 'string')) {
      throw new Error('Bundle.state: Wrong type: Got \'' + (typeof arg.state) + '\', but expected: \'string\'')
    }
    // Validate submittedAt
    if (arg.submittedAt && !(typeof arg.submittedAt === 'string')) {
      throw new Error('Bundle.submittedAt: Wrong type: Got \'' + (typeof arg.submittedAt) + '\', but expected: \'string\'')
    }
  }
  function buildBundle (arg) {
    var Bundle = arg
    // Complete assets
    // Expected Type: object
    Bundle.assets = Bundle.assets || {}
    // Complete assets.inspirational
    // Expected Type: array
    Bundle.assets.inspirational = Bundle.assets.inspirational || []
    // Complete assets.main
    // Expected Type: array
    Bundle.assets.main = Bundle.assets.main || []
    // Complete collection
    // Expected Type: array
    Bundle.collection = Bundle.collection || []
    // Complete deReleaseDate
    // Expected Type: string
    Bundle.deReleaseDate = Bundle.deReleaseDate || ''
    // Complete description
    // Expected Type: array
    Bundle.description = Bundle.description || []
    // Complete foundries
    // Expected Type: array
    Bundle.foundries = Bundle.foundries || []
    // Complete lastLiveUpdatedAt
    // Expected Type: string
    Bundle.lastLiveUpdatedAt = Bundle.lastLiveUpdatedAt || ''
    // Complete mode
    // Expected Type: string
    Bundle.mode = Bundle.mode || ''
    // Complete msrp
    // Expected Type: number
    Bundle.msrp = Bundle.msrp || 0
    // Complete name
    // Expected Type: string
    Bundle.name = Bundle.name || ''
    // Complete partNumber
    // Expected Type: string
    Bundle.partNumber = Bundle.partNumber || ''
    // Complete prices
    // Expected Type: array
    Bundle.prices = Bundle.prices || []
    // Complete state
    // Expected Type: string
    Bundle.state = Bundle.state || ''
    // Complete submittedAt
    // Expected Type: string
    Bundle.submittedAt = Bundle.submittedAt || ''
    return Bundle
  }
  return {
    validate: validateBundle,
    build: buildBundle
  }
})()

module.exports = Bundle
